import {useEffect,lazy,Suspense} from 'react';
import '@/App.css';
import {BrowserRouter,Routes,Route,useLocation} from 'react-router-dom';
import {HelmetProvider} from 'react-helmet-async';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import CustomCursor from '@/components/CustomCursor';
import {ScrollToTop,PageTransition} from '@/components/layout';
import Home from '@/pages/Home';
import Redirects from '@/components/Redirects';

const ServicePage=lazy(()=>import('@/pages/ServicePage'));
const PartnerPage=lazy(()=>import('@/pages/PartnerPage'));
const KurumsalSeyahatYonetimi=lazy(()=>import('@/pages/KurumsalSeyahatYonetimi'));
const Contact=lazy(()=>import('@/pages/Contact'));
const About=lazy(()=>import('@/pages/About'));
const CatchAll=lazy(()=>import('@/components/CatchAll'));
const BlogList=lazy(()=>import('@/pages/Blog').then(m=>({default:m.BlogList})));
const BlogPost=lazy(()=>import('@/pages/Blog').then(m=>({default:m.BlogPost})));
const Admin=lazy(()=>import('@/pages/Admin'));

const serviceSlugs=['ucak-bileti','otel-konaklama','vip-transfer','arac-kiralama','vize-hizmetleri','seyahat-sigortasi','etkinlik-organizasyon','plaza-flow'];

function Shell(){
  const isAdmin=useLocation().pathname.startsWith('/admin');
  if(isAdmin)return <Suspense fallback={null}><Routes><Route path="/admin" element={<Admin/>}/></Routes></Suspense>;
  return <>
    <CustomCursor/>
    <ScrollToTop/>
    <Redirects/>
    <Navbar/>
    <PageTransition>
      <main>
        <Suspense fallback={null}>
        <Routes>
          <Route path="/" element={<Home/>}/>
          {serviceSlugs.map(s=><Route key={s} path={'/'+s} element={<ServicePage slug={s}/>}/>) }
          <Route path="/kurumsal-seyahat-yonetimi" element={<KurumsalSeyahatYonetimi/>}/>
          <Route path="/atpi" element={<PartnerPage slug="atpi"/>}/>
          <Route path="/lufthansa-city-center" element={<PartnerPage slug="lufthansa-city-center"/>}/>
          <Route path="/hakkimizda" element={<About/>}/>
          <Route path="/iletisim" element={<Contact/>}/>
          <Route path="/plazette" element={<BlogList/>}/>
          <Route path="/plazette/:slug" element={<BlogPost/>}/>
          <Route path="*" element={<CatchAll/>}/>
        </Routes>
        </Suspense>
      </main>
    </PageTransition>
    <Footer/>
  </>;
}

function App(){
  useEffect(()=>{if('scrollRestoration' in window.history){window.history.scrollRestoration='manual';}},[]);
  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <Shell/>
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}
export default App;
